import React from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-media-placeholder">
        {/* Placeholder for Hero Image/Video */}
      </div>
      <div className="hero-content">
        <h1>Streamline Your Business Operations</h1>
        <p>Elevate your service quality and operational efficiency with CheckifAI. Our AI-powered checklists ensure consistency, reduce errors, and boost team productivity.</p>
        <button className="cta-button" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Start Your Free Trial</button>
      </div>
    </section>
  );
};

export default HeroSection;
